import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'line-haul-status-code',
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			hubid: '',
			hubname: '',
			createdby: '',
			shippingid: '',
			bagno: '',
			statuscode: '',
			trackafterhours: '',
			comments: '',
			statuscodelist: [],
			statuscodeitem: {
				value: '',
				text: ''
			},
			shipmentLimt:false,
			shipmentLimtMsg:'',
			bagLimt:false,
			bagLimtMsg:'',
			trackAfterHoursLimit:false,
			trackAfterHoursLimitMsg:'',
			isRedirect:false

		}
	},
	computed: {
		imsLink() {
			return process.env.NODE_ENV === 'production'
				? 'https://xbimslive.xbees.in/'
				: 'https://ims-frontend.xbees.in'
		}

	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.createdby = userdetail[0].email
		this.getHubName(this.hubid);
		this.getStatusCodeList();
	},
	methods: {
		getHubName(hubid) {
			this.input = {
				hubids: [hubid]
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubname = result.data.ResponseData[0].HubName;
					} else {
						this.hubname = '';
					}
				}, error => {
					console.error(error);
				})
		},
		getStatusCodeList() {
			this.input = ({})
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getLHReceiveStatusCode' + "?hubid=" + this.hubid,
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
				.then(result => {
					//HUB: 7735- redirect to IMS
					if (result.data.ResultCode && result.data.locToDownPage) {
						this.isRedirect = true;
						if (process.env.NODE_ENV == 'production') {
							window.open("https://xbimslive.xbees.in/", "_blank");
						} else {
							window.open("https://ims-frontend.xbees.in", "_blank");
						}
					}

					if (result.data.ResultCode == 100) {
						var StatusCodeList = result.data.ResultData
						for (var i = 0; i < StatusCodeList.length; i++) {
							this.statuscodelist.push({
								value: StatusCodeList[i].lhreceivestatuscode,
								text: StatusCodeList[i].lhreceivestatusname,
							})
						}
					} else {
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
				})
		},
		selectStatusCode(statuscodeitem) {
			this.statuscodeitem = statuscodeitem
			this.statuscode = statuscodeitem.text
		},

		updateLHStatusCode() {
			this.shipmentLimt=false
			this.shipmentLimtMsg=''
			this.bagLimt=false
			this.bagLimtMsg=''
			if(this.shippingid.length>500)
			{
				this.shipmentLimt=true
				this.shipmentLimtMsg="Please enter shipment's quantity upto 500"
				return false;
			}
			if(this.bagno.length>500)
			{
				this.bagLimt=true
				this.bagLimtMsg="Please enter bag's quantity upto 500"
				return false;
			}
			if(this.trackafterhours.length>5)
			{
				this.trackAfterHoursLimit=true
				this.trackAfterHoursLimitMsg="Please enter track after hours upto 5 digit"
				return false;
			}
			if(this.shippingid && typeof(this.shippingid) !== "string"){
			  this.shippingid=this.shippingid.join(',')
			}
			if(this.bagno && typeof(this.bagno) !== "string"){
			  this.bagno=this.bagno.join(',')
			}
			this.input = ({
				"currentHubId": this.hubid,
				"currentHubName": this.hubname,
				"lhReceiveStatusCode": this.statuscodeitem.value,
				"lhReceiveComments": this.comments, //Optional
				"shippingIds": this.shippingid, //Optional
				"lhTrackAfterHours": this.trackafterhours,
				"bagNos": this.bagno, //Optional
				"createdBy": this.createdby
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'updateLHStatusCodeByBagOrShip',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.resetForm();
					} else {
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
				})
		},
		resetForm() {
			this.shippingid = ''
			this.bagno = ''
			this.statuscode = ''
			this.trackafterhours = ''
			this.comments = ''
			this.statuscodeitem = {
				value: '',
				text: ''
			}
			this.$validator.reset()
			this.shipmentLimt=false
			this.shipmentLimtMsg=''
			this.bagLimt=false,
			this.bagLimtMsg=''
			this.trackAfterHoursLimit=false
			this.trackAfterHoursLimitMsg=''
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					if(this.shippingid)
					{
						if(/\r?\n|\r/g.test(this.shippingid) == true){
							this.shippingid = this.shippingid.replace(/\r?\n|\r/g,',');
						}
						if(/\s/g.test(this.shippingid) == true || this.shippingid.indexOf(',') > -1){
							this.shippingid = this.shippingid.replace(/\n|"|'| |,\s*$/g,'').split(',').filter(item => item);
						}
					}
					if(this.bagno){
						if(/\r?\n|\r/g.test(this.bagno) == true){
							this.bagno = this.bagno.replace(/\r?\n|\r/g,',');
						}
						if(/\s/g.test(this.bagno) == true || this.bagno.indexOf(',') > -1){
							this.bagno = this.bagno.replace(/\n|"|'| |,\s*$/g,'').split(',').filter(item => item);
						}
					}
					this.updateLHStatusCode();
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/LineHaulStatusCode/LineHaulStatusCode.js